/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from 'semantic-ui-react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';

import { useGoogleAnalytics } from 'volto-google-analytics';
const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div class="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>About</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/constitution">Constitution</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/code-of-ethics">Code of ethics</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/benefits-of-gissa-membership">Benefits of GISSA Membership</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/vendors-consultants">Vendors & Consultants</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/gissa-finances-fees-and-banking-details">Finances, Fees & Banking details</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>News & Events</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/news-events/news">News</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/news-events/events">Events</UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Regions</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/regions/national">National</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/regions/eastern-cape">Eastern Cape</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/regions/free-state">Free State</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/regions/gauteng">Gauteng</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/regions/kwazulu-natal">KwaZulu Natal</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/regions/limpopo">Limpopo</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/regions/mpumalanga">Mpumalanga</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/regions/northern-cape">Northern Cape</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/regions/north-west">North West</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/regions/western-cape">Western Cape</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>More</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/employment/cvs">CVs</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/employment/job-adverts">Job adverts</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/employment/career-listings">Career listings</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/sagc">SAGC</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/contact-us">Contact us</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={6} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item className="footer-sitesocial">
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="#"
                            target="_blank"
                            title="Facebook"
                          >
                            <i class="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="#"
                            target="_blank"
                            title="X"
                          >
                            <i class="bi bi-twitter-x"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="#"
                            target="_blank"
                            title="YouTube"
                          >
                            <i class="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="#"
                            target="_blank"
                            title="YouTube"
                          >
                            <i class="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      <FormattedMessage
                        id="{copyright} Geo-Information Society of South Africa {current_year}"
                        defaultMessage="{copyright} Geo-Information Society of South Africa {current_year}"
                        values={{
                          copyright: (
                            <abbr
                              title={intl.formatMessage(messages.copyright)}
                            >
                              ©
                            </abbr>
                          ),
                          current_year: new Date().getFullYear(),
                        }}
                      />
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      Stock images/videos courtesy of <a href="https://www.pexels.com" target="_blank">Pexels</a> & <a href="https://unsplash.com" target="_blank">Unsplash</a>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="#top"
                        class="header-link"
                        title="Back to top"
                      >
                        <i class="bi bi-arrow-up-square"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div class="belowFooter">
        <a href="https://juizi.com" target="_blank">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
